export default "__VITE_ASSET__8f07155a__"